import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background-color: ${props => props.theme.colors.lightGray};
  padding: 60px 20px;
  border-top: 1px solid ${props => props.theme.colors.border};
  color: ${props => props.theme.colors.textSub};
  font-size: 14px;
`;

const FooterContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 1200px;
  margin: 0 auto;
`;

const CompanyInfo = styled.div`
  flex: 1;
  .logo {
    font-size: 1.5rem;
    font-weight: 800;
    color: white;
    margin-bottom: 20px;
  }
  p {
    font-size: 0.9rem;
    line-height: 1.8;
    margin-bottom: 5px;
  }
  /* 정보 줄(그룹) 간 세로 간격 */
  & > div {
    margin-bottom: 2px;
    line-height: 1.9;
  }
  /* 같은 줄 항목(상호/대표자/사업자번호, TEL/FAX/E-mail) 간 가로 간격 */
  span {
    display: inline-block;
    margin-right: 28px;
  }
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 24px; /* 인증 로고 간 간격 (너무 붙지 않게) */
`;

const LogoItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LogoImage = styled.img`
  height: 50px; /* 로고 크기에 맞춰 적절히 조절 */
  width: auto;
  max-width: 90px; /* 가로로 긴 로고(ISO 등)가 과도하게 커지지 않도록 폭 제한 */
  object-fit: contain;
`;

const LogoLabel = styled.span`
  margin-top: 8px;
  font-size: 13px;
  font-weight: 700;
  color: ${props => props.theme.colors.textSub};
  text-align: center;
  white-space: nowrap;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <LogoWrapper>
          <LogoItem>
            <LogoImage src="/images/logo_socialenterprise.png" alt="사회적기업" />
            <LogoLabel>사회적기업</LogoLabel>
          </LogoItem>
          <LogoItem>
            <LogoImage src="/images/logo_womanenterprise.png" alt="여성기업" />
            <LogoLabel>여성기업</LogoLabel>
          </LogoItem>
          <LogoItem>
            <LogoImage src="/images/logo_korea_government.png" alt="중소기업" />
            <LogoLabel>중소기업</LogoLabel>
          </LogoItem>
          <LogoItem>
            <LogoImage src="/images/logo_iso45001.png" alt="ISO45001" />
            <LogoLabel>ISO45001</LogoLabel>
          </LogoItem>
          {/* 경기도·의정부시 지자체 CI — 사칭/오해 소지로 숨김 (승인 근거 확보 시 복원) */}
          {/* <LogoImage src="/images/logo_ggd.png" alt="경기도" /> */}
          {/* <LogoImage src="/images/logo_ujb.png" alt="의정부" /> */}
        </LogoWrapper>

        <CompanyInfo>
          <div>
            <span><strong>상호 :</strong> 주식회사 두성시스템</span>
            <span><strong>대표자 :</strong> 유은미</span>
            <span><strong>사업자등록번호 :</strong> 127-86-10199</span>
          </div>
          <div>
            <span><strong>주소 :</strong> 경기도 의정부시 상금로 33 이롬프라자 506호</span>
          </div>
          <div>
            <span><strong>TEL :</strong> 031-871-4424/5</span>
            <span><strong>FAX :</strong> 031-871-4426</span>
            <span><strong>E-mail :</strong> doosung0601@hanmail.net</span>
          </div>
          <div className="copyright">
            Copyright © 2008 DOOSUNGSYSTEM All rights reserved.
          </div>
        </CompanyInfo>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;